import { render, staticRenderFns } from "./HeaderBoxRegistro.vue?vue&type=template&id=512cfe16&scoped=true&"
import script from "./HeaderBoxRegistro.vue?vue&type=script&lang=js&"
export * from "./HeaderBoxRegistro.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBoxRegistro.vue?vue&type=style&index=0&id=512cfe16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512cfe16",
  null
  
)

export default component.exports